module.exports = __webpack_public_path__ + "media/images/webpage/coupons/coupon/cover-sp-a472c6fca4dc54a5205144e3e93ee2de.webp";